import usingServiceAdvantage from './usingPizzaAdvantage';
import frequentlyAskedQuestions from './pizza-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Pizza POS System',
      description: `Chowbus POS is as easy as pie!`,
    },
    zh: {
      title: 'Chowbus POS系统: 美国披萨店点餐首选，专为披萨店设计的点餐系统',
      description: '使用Chowbus披萨店点餐系统让开店变得小菜一碟',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended products to power your Pizzeria',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
